export function initializeBackgroundVideos() {
  const desktop = window.matchMedia('(min-width: 768px)');
  const iframes = document.querySelectorAll('.video-foreground iframe[data-src]');

  if (!iframes.length) return;

  const loadVideo = (iframe) => {
    if (desktop.matches && !iframe.hasAttribute('src')) {
      iframe.setAttribute('src', iframe.dataset.src);
    }
  };

  if (!('IntersectionObserver' in window)) {
    iframes.forEach(loadVideo);
    desktop.addEventListener('change', () => iframes.forEach(loadVideo));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting || !desktop.matches) return;

      loadVideo(entry.target);
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '200px 0px' });

  iframes.forEach((iframe) => observer.observe(iframe));
}
